import {Component, inject, Input} from '@angular/core';
import {Button} from 'primeng/button';
import {MailboxConfiguratorFacade} from '../../../mailbox-configurator.facade';
import {FormGroup} from '@angular/forms';

@Component({
	selector: 'app-review-step',
	standalone: true,
	template: `
		<div class="w-full flex flex-column gap-4">

			<!-- INBOUND -->
			<div>
				<h3>Inbound</h3>
				<div class="grid">
					<div class="col-6"><b>Provider:</b> {{ inboundForm.value.client }}</div>
					<div class="col-6"><b>Email:</b> {{ inboundForm.value.email }}</div>
					<div class="col-6"><b>Username:</b> {{ inboundForm.value.username }}</div>
					<div class="col-6"><b>Password:</b> ••••••••</div>

					@if (inboundForm.value.host) {
						<div class="col-6"><b>Host:</b> {{ inboundForm.value.host }}</div>
					}

					@if (inboundForm.value.imap_port) {
						<div class="col-6"><b>IMAP Port:</b> {{ inboundForm.value.imap_port }}</div>
					}

					@if (inboundForm.value.protocol) {
						<div class="col-6"><b>Protocol:</b> {{ inboundForm.value.protocol }}</div>
					}

					<div class="col-6"><b>SSL:</b> {{ inboundForm.value.ssl_enabled ? 'Sì' : 'No' }}</div>
					<div class="col-6"><b>StartTLS:</b> {{ inboundForm.value.start_tls_enabled ? 'Sì' : 'No' }}</div>
				</div>
			</div>

			<!-- OUTBOUND -->
			<div>
				<h3>Outbound</h3>
				<div class="grid">
					<div class="col-6"><b>Provider:</b> {{ outboundForm.value.client }}</div>
					<div class="col-6"><b>Email:</b> {{ outboundForm.value.email }}</div>
					<div class="col-6"><b>Username:</b> {{ outboundForm.value.username }}</div>
					<div class="col-6"><b>Password:</b> ••••••••</div>

					<div class="col-6"><b>Alias:</b> {{ outboundForm.value.email_configuration_alias }}</div>
					<div class="col-6"><b>From Name:</b> {{ outboundForm.value.from_name }}</div>
					<div class="col-6"><b>From Address:</b> {{ outboundForm.value.from_address }}</div>

					@if (outboundForm.value.host) {
						<div class="col-6"><b>Host:</b> {{ outboundForm.value.host }}</div>
					}

					@if (outboundForm.value.smtp_port) {
						<div class="col-6"><b>SMTP Port:</b> {{ outboundForm.value.smtp_port }}</div>
					}

					<div class="col-6"><b>Auth:</b> {{ outboundForm.value.email_auth ? 'Sì' : 'No' }}</div>
					<div class="col-6"><b>StartTLS:</b> {{ outboundForm.value.starttls_enable ? 'Sì' : 'No' }}</div>
				</div>
			</div>

			<!-- ACTIONS -->
			<div class="flex justify-content-between gap-2">
				<p-button (onClick)="facade.back()" severity="secondary">Indietro</p-button>
				<p-button (onClick)="save()"
						  label="Salva"
						  variant="outlined"
						  severity="success"></p-button>
			</div>

		</div>
	`,
	imports: [Button]
})
export class ReviewStepComponent {
	protected facade = inject(MailboxConfiguratorFacade)

	@Input({ required: true }) inboundForm!: FormGroup;
	@Input({ required: true }) outboundForm!: FormGroup;

	save() {
		if (this.inboundForm.invalid || this.outboundForm.invalid) {
			this.inboundForm.markAllAsTouched();
			this.outboundForm.markAllAsTouched();
			return;
		}

		console.log('SALVATAGGIO COMPLETO', {
			inbound: this.inboundForm.value,
			outbound: this.outboundForm.value
		});

		this.facade.saveConfigurations(
			this.inboundForm.getRawValue(),
			this.outboundForm.getRawValue()
		).subscribe({
			next: () => {
				console.log('SALVATAGGIO COMPLETATO');
			},
			error: (err) => {
				console.error('Errore durante il salvataggio', err);
			}
		});
	}
}
